var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sc-user-input--button-icon-wrapper microphonebtn",style:({ color: _vm.activeColor })},[_c('i',{staticClass:"fa fa-microphone d-inline-block",staticStyle:{"{font-weight":"100}"},attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }